export default {
  firmBio: "profile/firmBio",
  getfirmBio: "profile/firmBio",
  update: "profile/firmBio/update",
};
